import tabsTemplates from './tabsTemplates';

import {
  Standard,
  Counter,
  Section,
} from './tabsLayouts';

const tabsSet = [
  {
    type: 'standard',
    previews: [
      {
        component: Standard,
        codeTemplate: tabsTemplates.standard,
        optionsGroup: [
          {
            label: 'Text Without Counter',
            options: [
              {label: 'only text', type: 'radio', options:{withIcon: false}},
              {label: 'with icon', type: 'radio', options:{withIcon: true}},
            ]
          },
          {
            label: 'Version',
            options: [
              {label: 'large', type: 'radio', options: {large: true}},
              {label: 'small', type: 'radio', options: {large: false}},
            ]
          },
          {
            label: 'Background',
            options: [
              {
                label: 'rows', type: 'dropdown', selectList: [
                  {label: 'Colour', value: 'colour', options: {bgColor: null}},
                  {label: 'Dark blue', value: 'dark-blue', options: {bgColor: 'dark-blue'}},
                  {label: 'Dark purple', value: 'dark-purple', options: {bgColor: 'dark-purple'}},
                  {label: 'Dark red', value: 'dark-red', options: {bgColor: 'dark-red'}},
                  {label: 'Grey', value: 'grey', options: {bgColor: 'grey'}},
                  {label: 'Heavy blue', value: 'heavy-blue', options: {bgColor: 'heavy-blue'}},
                  {label: 'Purple', value: 'purple', options: {bgColor: 'purple'}},
                  {label: 'Red', value: 'red', options: {bgColor: 'red'}},
                  {label: 'Black', value: 'black', options: {bgColor: 'black'}},
                ]
              },
            ]
          },
        ],
      },
    ]
  },
  {
    type: 'counter',
    previews: [
      {
        component: Counter,
        codeTemplate: tabsTemplates.counter,
        optionsGroup: [
          {
            label: 'Text With Counter',
            options: [
              {label: 'large', type: 'radio', options:{size:'l'} },
              {label: 'medium', type: 'radio', options:{size:'m'} },
              {label: 'small', type: 'radio', options:{size:'s'} },
            ]
          },
          {
            label: 'Background',
            options: [
              {
                label: 'rows', type: 'dropdown', selectList: [
                  {label: 'Colour', value: 'colour', options: {bgColor: null}},
                  {label: 'Dark blue', value: 'dark-blue', options: {bgColor: 'dark-blue'}},
                  {label: 'Dark purple', value: 'dark-purple', options: {bgColor: 'dark-purple'}},
                  {label: 'Dark red', value: 'dark-red', options: {bgColor: 'dark-red'}},
                  {label: 'Grey', value: 'grey', options: {bgColor: 'grey'}},
                  {label: 'Heavy blue', value: 'heavy-blue', options: {bgColor: 'heavy-blue'}},
                  {label: 'Purple', value: 'purple', options: {bgColor: 'purple'}},
                  {label: 'Red', value: 'red', options: {bgColor: 'red'}},
                  {label: 'Black', value: 'black', options: {bgColor: 'black'}},
                ]
              },
            ]
          },
        ],
      },
    ]
  },
  {
    type: 'section',
    previews: [
      {
        component: Section,
        codeTemplate: tabsTemplates.section,
        optionsGroup: [
          {
            label: 'Vertical Section',
            options: [
              {label: 'only text', type: 'radio', options: {bgColor: 'black', icons: false}},
              {label: 'with icon', type: 'radio', options: {icons: true}},
            ]
          },
          {
            label: 'Rows',
            options: [
              {
                label: 'rows', type: 'dropdown', selectList: [
                  {label: '2 Rows', value: '2', options: {rows: '2',}},
                  {label: '3 Rows', value: '3', options: {rows: '3',}},
                  {label: '4 Rows', value: '4', options: {rows: '4',}},
                  {label: '5 Rows', value: '5', options: {rows: '5',}},
                ]
              },
            ]
          },
        ],
      },
      {
        component: Section,
        codeTemplate: tabsTemplates.horizontalSection,
        optionsGroup: [
          {
            label: 'Horizontal Section',
            options: [
              {label: 'only text', type: 'radio', options: {horizontal: true, bgColor: 'black', icons: false}},
              {label: 'with icon', type: 'radio', options: {icons: true}},
            ]
          },
          {
            label: 'Rows',
            options: [
              {
                label: 'rows', type: 'dropdown', selectList: [
                  {label: '2 Rows', value: '2', options: {rows: '2',}},
                  {label: '3 Rows', value: '3', options: {rows: '3',}},
                  {label: '4 Rows', value: '4', options: {rows: '4',}},
                  {label: '5 Rows', value: '5', options: {rows: '5',}},
                ]
              },
            ]
          },
        ],
      },
    ]
  },
];

export default tabsSet;



// WEBPACK FOOTER //
// ./src/containers/elements/Tabs/constants/tabsSet.js